import styled, { createGlobalStyle } from 'styled-components';
import { ModalGlobalStyleMixin } from '../../mixins/components/ModalGlobalStyleMixin';
export var StyledModal = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledModal",
  componentId: "c11n-8-107-0__sc-1rx4oah-0"
})([""]);
export var ModalGlobalStyle = /*#__PURE__*/createGlobalStyle(["", ""], ModalGlobalStyleMixin);